const inkeep_ai_bot = {
    intro_message: 'Hi，我是 Logto AI！\n\n我是一个在文档、帮助文章和其他内容上训练的 AI 助手。\n\n问我有关 `Logto` 的任何问题。',
    chat_placeholder: '向 Logto AI 询问你的问题，获取详细指南',
    disclaimer_label: 'Logto AI 免责声明',
    disclaimer_tooltip: '回复内容由 AI 生成，可能需要进一步核实。',
    example_questions_label: '示例问题',
    example_questions: ['Logto 设置的快速入门指南', '配置多租户架构', '如何集成用户档案？'],
    stop: '停止',
    clear: '重新开始',
    get_help: '获取帮助',
    copy_chat: '复制',
    ask_ai_label: '询问 AI',
    contact: '联系我们',
    discord: 'Discord 社区',
};
export default Object.freeze(inkeep_ai_bot);
